import { ConfigProvider } from 'antd'
import { Spin } from 'antd'
import jaJP from 'antd/locale/ja_JP'
import { type FC, type ReactNode } from 'react'

import { Spinner } from '@/components/elements'

import { theme } from './theme'

Spin.setDefaultIndicator(<Spinner />)

type AntdProviderProps = {
  children: ReactNode
}

export const AntdProvider: FC<AntdProviderProps> = ({ children }) => (
  <ConfigProvider
    button={{ autoInsertSpace: false }}
    theme={theme}
    locale={jaJP}
  >
    {children}
  </ConfigProvider>
)
